export const LOADBOARD_CHANGE_TRACKING = {
  multiPost: {
    source: 'loadboard.multi_post',
    id: 23001,
  },
  multiUnpost: {
    source: 'loadboard.multi_unpost',
    id: 23002,
  },
  postingComments: {
    source: 'loadboard.multi_post.posting_comments',
    id: 23003,
  },
  statusChange: {
    source: 'loadboard.status_change',
    id: 23004,
  },
  sidePanelLoadStatus: {
    source: 'loadboard.side_panel.load_status',
    id: 23005,
  },
  sidePanelFlagCreate: {
    source: 'loadboard.side_panel.load.flag.create',
    id: 23006,
  },
  sidePanelFlagUpdate: {
    source: 'loadboard.side_panel.load.flag.update',
    id: 23007,
  },
  sidePanelFlagDelete: {
    source: 'loadboard.side_panel.load.flag.delete',
    id: 23008,
  },
  sidePanelFlagAddComment: {
    source: 'loadboard.side_panel.load.flag.add_comment',
    id: 23009,
  },
  sidePanelFlagDeleteComment: {
    source: 'loadboard.side_panel.load.flag.delete_comment',
    id: 23010,
  },
  sidePanelFlagDispute: {
    source: 'loadboard.side_panel.load.flag.dispute',
    id: 23011,
  },
  sidePanelScheduleCheckCall: {
    source: 'loadboard.side_panel.tracking.schedule_check_call',
    id: 23012,
  },
  sidePanelTrackingAddComment: {
    source: 'loadboard.side_panel.tracking.add_comment',
    id: 23013,
  },
  sidePanelTrackingDeleteComment: {
    source: 'loadboard.side_panel.tracking.delete_comment',
    id: 23014,
  },
  sidePanelTrackingSendCustomerUpdate: {
    source: 'loadboard.side_panel.tracking.send_customer_update',
    id: 23015,
  },
  sidePanelTrackingUpdateVisibility: {
    source: 'loadboard.side_panel.tracking.update_visibility',
    id: 23016,
  },
  sidePanelStopsUpdateDriverInOutTimes: {
    source: 'loadboard.side_panel.stops.update_driver_in_out_times',
    id: 23017,
  },
  sidePanelCarrierOffers: {
    source: 'loadboard.side_panel.carrier_offers.update',
    id: 23018,
  },
  sidePanelLtlQuoteInsuranceDelete: {
    source: 'loadboard.side_panel.ltl_quote.insurance.delete',
    id: 23019,
  },
  massShareCapacity: {
    source: 'loadboard.mass_share_capacity',
    id: 23020,
  },
  // Datadog-only: tags product feedback, never sent as a change-source header.
  loadboardPageFeedback: {
    source: 'loadboard.page_feedback',
    id: 23900,
  },
} as const;
